import { UrlSegment, UrlMatchResult } from '@angular/router';

export function userProfileAtMatcher(url: UrlSegment[]): UrlMatchResult | null {
    console.log('url from profileMatcher', url);

    if (url.length === 1 && url[0].path.startsWith('@')) {
        console.log('url has @', url);
        const username = url[0].path.substring(1);

        return {
            consumed: url,
            posParams: {
                username: new UrlSegment(username, {})
            }
        };
    }

    return null;
}